import React, { useRef } from 'react';
import { gsap } from 'gsap';
import './Button.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrash, faPlus, faSave, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Button = ({
  type = 'button',
  variant = 'primary',
  className = '',
  children,
  disabled = false,
  fullWidth = false,
  onClick,
}) => {
  const btnRef = useRef(null);

  const isSubmittingRef = useRef(false);

  const handleClick = async (e) => {
    if (disabled || isSubmittingRef.current) return;

    isSubmittingRef.current = true;

    gsap.fromTo(
      btnRef.current,
      { scale: 1, opacity: 1 },
      {
        scale: 0.97,
        opacity: 0.85,
        duration: 0.15,
        yoyo: true,
        repeat: 1,
        ease: 'power1.inOut',
      }
    );

    try {
      if (onClick) {
        const result = onClick(e);
        if (result instanceof Promise) {
          await result; // Aguarda finalização do submit (caso async)
        }
      }
    } finally {
      setTimeout(() => {
        isSubmittingRef.current = false; // Libera cliques após 2s 
      }, 2000);
    }
  };



  let icon = null;
  switch (variant) {
    case 'edit':
      icon = <FontAwesomeIcon icon={faPencilAlt} />;
      break;
    case 'delete':
      icon = <FontAwesomeIcon icon={faTrash} />;
      break;
    case 'add':
      icon = <FontAwesomeIcon icon={faPlus} />;
      break;
    case 'save':
      icon = <FontAwesomeIcon icon={faSave} />;
      break;
    case 'send':
      icon = <FontAwesomeIcon icon={faPaperPlane} />;
      break;
    default:
      icon = null;
  }

  const buttonClass =
    `btn ${variant} ${className} ${disabled ? 'disabled' : ''} ${fullWidth ? 'btn-fullwidth' : ''
    }  ${isSubmittingRef.current ? 'btn-processing' : ''}`;

  return (
    <button
      ref={btnRef}
      type={type}
      className={buttonClass}
      disabled={disabled}
      onClick={handleClick}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      <span className="btn-text">{children}</span>
    </button>
  );
};

export default Button;
